export function toggleStandardLoopCharacteristicsIcon(params: any, modeling: any, moddle: any) {

  return {
    args: [
      params.element("element")
    ],
    exec: (element: BpmnJsElement) => {
      if (!element.businessObject.loopCharacteristics) {
        const loopCharacteristics = moddle.create("bpmn:StandardLoopCharacteristics");
        loopCharacteristics.isLoop = true;
        return modeling.updateProperties(element,
          {
            loopCharacteristics: loopCharacteristics
          });
      } else {
        return modeling.updateProperties(element,
          {
            loopCharacteristics: null
          });
      }
    }
  };
}

toggleStandardLoopCharacteristicsIcon.$inject = ["cli._params", "modeling", "moddle"];
